import { useMemo, useCallback } from "react";
import { toast } from "react-toastify";
import { isWithinTimeRange } from "components/Menu/WaiterMenu/Cart/isWithinTimeRange";

export const useHolidayGuard = (restaurantsDetail, orderType = "dinein") => {
  const holidayStatus = useMemo(() => {
    if (!restaurantsDetail) {
      return { isHoliday: false, storeTiming: true, type: null, title: "" };
    }

    const isToday = (dateString) => {
      const givenDate = new Date(dateString);
      const today = new Date();
      return (
        givenDate.getFullYear() === today.getFullYear() &&
        givenDate.getMonth() === today.getMonth() &&
        givenDate.getDate() === today.getDate()
      );
    };

    const todayHoliday = restaurantsDetail?.holidays?.find((holiday) =>
      isToday(holiday.date)
    );

    const dineInAvailable = isWithinTimeRange(restaurantsDetail?.storeTiming);

    let result = {
      isHoliday: false,
      storeTiming: true,
      type: null,
      title: "",
    };

    if (todayHoliday) {
      result = {
        ...result,
        isHoliday: true,
        title: todayHoliday?.title || "Holiday",
      };
    }

    if (orderType === "dinein" && !dineInAvailable) {
      result = {
        ...result,
        storeTiming: false,
        type: "dinein",
      };
    }

    return result;
  }, [restaurantsDetail, orderType]);

  const checkAndToast = useCallback(() => {
    if (!holidayStatus.type && !holidayStatus.isHoliday) return false;

    const typeLabel = holidayStatus?.type === "dinein" && "Dine-in";
    const typeIcon = holidayStatus?.type === "dinein" && "🍽️";

    toast.warning(
      holidayStatus?.isHoliday
        ? `📅 Attention: The ${restaurantsDetail?.name} store is closed today due to ${holidayStatus?.title}. Please check back tomorrow.`
        : `${typeIcon} Notice: ${typeLabel} service is currently unavailable as operating hours have ended. Please check back tomorrow.`,
      {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: {
          backgroundColor: "#fff3cd",
          color: "#856404",
          fontWeight: "500",
          fontSize: "15px",
        },
      }
    );

    return true; // block further action
  }, [holidayStatus, restaurantsDetail?.name]);

  return { holidayStatus, checkAndToast };
};
